// Main Classes
const root = (theme) => ({
  paddingTop: theme.spacing(2), // Matches the marginBottom of each link
  display: 'grid',
  gridTemplateColumns: '1fr 1.5fr 1.5fr',
  gap: theme.spacing(2),
  borderTop: `1px solid ${theme.palette.facet.mediumGray}`,
});

const section = (theme) => ({
  color: theme.palette.facet.darkGray,
});

const title = (theme) => ({
  fontSize: theme.typography.fontSize1Pt125Rem,
  fontWeight: theme.typography.fontWeightExtraBold,
  lineHeight: `${theme.spacing(3.5)}px`,
});

const descriptionContainer = () => ({});

const descriptionText = (theme) => ({
  lineHeight: `${theme.spacing(3.5)}px`,
});

const links = () => ({
  display: 'flex',
  flexDirection: 'column',
});

const linkButtonWrapper = () => ({
  justifyContent: 'flex-end',
  display: 'flex',
});

const link = (theme) => ({
  fontWeight: theme.typography.fontWeightMedium,
  fontSize: theme.typography.fontSize1Pt125Rem,
  padding: '0px 8px',
  marginBottom: theme.spacing(2),
  lineHeight: `${theme.spacing(4)}px`,
  whiteSpace: 'nowrap',
  borderRadius: '30px',
});

const button = (theme) => ({
  marginTop: theme.spacing(2),
});

// Mobile Classes
const mobile = () => ({
  display: 'flex',
  flexDirection: 'column',
});

const descriptionTextMobile = () => ({
  textAlign: 'start',
});

const linkMobile = () => ({
  justifyContent: 'flex-start',
});

export {
  root,
  section,
  title,
  descriptionContainer,
  descriptionText,
  links,
  link,
  linkButtonWrapper,
  button,
  mobile,
  descriptionTextMobile,
  linkMobile,
};
